<div class="idioma-selector">
  <!-- <span i18n="@@web-inscripciones.seleccione-idioma">Seleccione idioma</span>:  -->
  <mat-select  #selidiomas 
    [(ngModel)]="idioma_actual" 
    (ngModelChange)="cambiarIdioma($event)" 
    class="idioma-select"
    aria-label="Selector de idioma">
    <mat-select-trigger>
        @if (idiomaActual() === 'ca') {
          <div class="idioma-option">
            <img 
              src="assets/imgs/cat.png" 
              width="20" 
              height="15"
              class="bandera-icono"
            />
            catalan
          </div>
        } 
        @else {
          <div class="idioma-option">
            {{ getBandera(idiomaActual()) }}
            {{ getNombreIdioma(idiomaActual()) }}
          </div>
        }
    </mat-select-trigger>
    
    @for (idioma of idiomas(); track idioma.codigo) {
      <mat-option [value]="idioma.codigo">
        @if (idioma.codigo === 'ca') {
          <div class="idioma-option">
            <img 
              [src]="idioma.bandera" 
              width="20" 
              height="15"
              class="bandera-icono"
            />
            {{ idioma.nombre }}
          </div>
        } @else {
          <div class="idioma-option">
            {{ idioma.bandera }}
            {{ idioma.nombre }}
          </div>
        }
      </mat-option>
    }
  </mat-select >
  
</div>
